export enum OrderIncompleteDeliveryReason {
  ItemsMissing = 'ITEMS_MISSING',
  ItemDamaged = 'ITEM_DAMAGED',
  Other = 'OTHER',
}

export interface OrderIncompleteDeliveryReport {
  reason: OrderIncompleteDeliveryReason;
  comment?: string;
}

export interface OrderUnresolvedIncompleteDelivery {
  id: string;
  reason: OrderIncompleteDeliveryReason;
  comment?: string;
}

export class OrderIncompleteDeliveryAlreadyReportedError extends Error {
  constructor(orderId: string) {
    super(`Incomplete delivery already reported for order ${orderId}`);
    this.name = 'OrderIncompleteDeliveryAlreadyReportedError';
  }
}
